import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { inject } from '@angular/core';
import { LoginService } from './login.service';
import { switchMap } from 'rxjs';
import { HttpContextToken } from '@angular/common/http';

export const BYPASS_TPI_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export const AddAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const ignoreAuthRequests = ['user-login', 'org', 'oauth'];

  // Check if the request URL contains any of the ignoreRequests
  if (ignoreAuthRequests.some(url => req.url.includes(url))) {
    return next(req);
  }

  // Clone the request and add the custom header
  // const modifiedRequest = req.clone({
  //   setHeaders: {
  //     'e_api_key': environment.eApiKey
  //   }
  // });
  // return next(modifiedRequest);
  return next(req);
};


export const AddTpiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(BYPASS_TPI_INTERCEPTOR)) {
    return next(req);
  }
  const allowAuthRequests = ['dfs', 'wallet'];

  if (!allowAuthRequests.some(url => req.url.includes(url))) {
    return next(req);
  }

  const ignoreAuthRequests = ['user-login', 'org'];
  
  if (ignoreAuthRequests.some(url => req.url.includes(url))) {
    return next(req);
  }

  const ignoreTpiRequests: string[] = [];
  const loginService = inject(LoginService);

  if (environment.whiteLabel) {
    const utmSource = environment.whiteLabel;
    const modifiedRequest = req.clone({
      setParams: {
        utmSource
      }
    });
    return next(modifiedRequest);
  }

  return loginService.isLoggedIn().pipe(
    switchMap(isLoggedIn => {
      if (!isLoggedIn) {
        return next(req);
      } else {
        return loginService.getUtmSource().pipe(
          switchMap(utmSource => {
            if (ignoreTpiRequests.some(url => req.url.includes(url)) || !utmSource) {
              return next(req);
            }

            const modifiedRequest = req.clone({
              setParams: {
                utmSource
              }
            });
            return next(modifiedRequest);
          })
        );  
      }
    })
  );
};

